import React, {PureComponent} from 'react';
import {filter} from 'lodash';
import {TeamMember, Category} from '../index';
import PedroSm from '../../assets/img/team/pedro.jpg';
import CarolinaSM from '../../assets/img/team/carolina.jpg';

class Team extends PureComponent {

  render() {
    const {values} = this.props;
    const team = filter(values, {'type': 'person'});
    const categories = filter(values, {'type': 'generic'});

    return (
      <div className="team">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2 className="section-heading">Team</h2>
          </div>
        </div>
        <div className="row team-members">
          {
            team.map((teamMember, index) => {
              return (
                <div key={index} className="col-sm-6 col-lg-6">
                  <TeamMember {...teamMember}/>
                </div>
              );
            })
          }
        </div>
        <div className="xpto row">
          {
            categories.map((categoryObj, index) => {
              return (
                <div key={index} className="col-lg-4 col-sm-4">
                  <Category {...categoryObj}/>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}

export default Team;



// WEBPACK FOOTER //
// ./src/components/team/Team.js